<template>
    <div
        class="flex flex-col overflow-hidden border-r border-ds-primary-200 bg-ds-primary-50 py-2 transition-all duration-200 ease-in-out"
        :class="expanded ? 'w-[75vw] legacy-md:w-64' : 'w-0 legacy-md:w-16'"
    >
        <div class="mb-2 flex justify-end">
            <div
                class="expansion-control-shadow -border hidden w-5 cursor-pointer items-center rounded-l-[4px] border-ds-red-500 bg-ds-primary-100 py-1 text-center hover:bg-ds-primary-200 legacy-md:inline-block"
                @click="toggleSideNav"
            >
                <ChevLeft
                    v-if="expanded"
                    with-shadow
                />
                <ChevRight
                    v-else
                    with-shadow
                />
            </div>
        </div>

        <slot
            :is-panel-expanded="expanded"
            name="content"
        ></slot>
    </div>
</template>

<script setup lang="ts">
import ChevLeft from '@/components/Icons/ChevLeft.vue';
import ChevRight from '@/components/Icons/ChevRight.vue';
import { useCompanyNavigationStore } from '@/stores/company/company-navigation.store';
import hotkeys from 'hotkeys-js';
import { onMounted, onUnmounted } from 'vue';

const companyNavigationStore = useCompanyNavigationStore();

// declare slots expanded and collapsed
defineSlots<{
    content: (props: { isPanelExpanded: boolean }) => void;
}>();

function toggleSideNav() {
    expanded.value = !expanded.value;
    companyNavigationStore.setShowSideNav(!expanded.value);
}

const expanded = defineModel<boolean>('expanded', { default: true });

onMounted(() => {
    hotkeys('ctrl+.,cmd+.', () => {
        toggleSideNav();
    });

    expanded.value = companyNavigationStore.showSideNav;
});

onUnmounted(() => {
    hotkeys.unbind('ctrl+.,cmd+.');
});
</script>

<style scoped>
.expansion-control-shadow {
    box-shadow:
        0px 1px 2px -1px rgba(16, 24, 40, 0.1),
        0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
</style>
